import { Frequency } from '../../../../store/types/prescription';

export const convertToNewField = (frequency?: Frequency): string => {
    if (!frequency) return '';
    return frequency.type === 'custom'
        ? frequency.custom || ''
        : frequency.type === 'code'
        ? frequency.code || ''
        : frequency.type === 'SOS'
        ? 'SOS'
        : frequency.type === 'toContinue'
        ? 'To continue'
        : frequency.type === 'onceEvery'
        ? `Once every ${frequency.onceEvery?.value} ${frequency.onceEvery?.unit}`
        : '';
};
